<template>
  <div>
    <div v-if="isBusy || loading" class="text-center text-danger my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ml-1">{{ $t('CATALOG_LOADING_LABEL', {catalog: $t('COMPANIES')}) | capitalize }}</strong>
    </div>
    <b-card bg-variant="dark" text-variant="light" v-else :title="title || $t('COMPANIES')">
      <b-card-text>
        <b-button class="mb-2" variant="info" @click="showModal">
          {{ $t('FORMS_MULTI_SELECT_LABEL', {catalog: $t('COMPANY')}) | capitalize }}
        </b-button>
        <b-list-group>
          <b-list-group-item variant="dark" :key="item.id" v-for="item of current">{{ $t(item.name) }}
          </b-list-group-item>
        </b-list-group>
        <b-modal id="company-modal" size="xl" @ok="handleInput">
          <company-list :only-active="true" :only-donors="onlyDonors" :currently-selected="currentHrefs" @change="storeSelected"></company-list>
        </b-modal>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {LoadData, SendsMessages, VModel} from "@/mixins";
import CompanyList from "@/company/CompanyList";

export default {
  name: "CompanySelector",
  components: {CompanyList},
  props: ['title', 'loading', 'value', 'initialValues', 'onlyDonors'],
  mixins: [LoadData, VModel, SendsMessages],
  mounted() {
    this.currentHrefs = this.value;
    this.current = this.initialValues;
  },
  watch: {
    value(val) {
      this.currentHrefs = val;
    },
    initialValues(val) {
      this.current = val;
    }
  },
  methods: {
    storeSelected(selected) {
      this.selected = selected;
      console.log('selected')
      console.log(this.selected);
      this.selectedHrefs = selected.map(x => x._links.self.href);
    },
    async showModal() {
      this.$bvModal.show('company-modal');
    },
    handleInput() {
      this.$emit('input', this.selectedHrefs);
      this.current = this.selected;
      this.currentHrefs = this.current.map(x => x._links.self.href)
      this.selected = [];
      this.selectedHrefs = [];
    }
  },
  data() {
    return {
      search: '',
      permissions: [],
      content: this.value,
      selected: [],
      selectedHrefs: [],
      current: [],
      currentHrefs: []
    }
  },
}
</script>

<style scoped>

</style>
